import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Star, 
  MapPin, 
  Phone, 
  Shield, 
  Clock,
  Luggage,
  Users,
  Mountain,
  Car,
  Wifi,
  Coffee,
  Battery
} from 'lucide-react';
import { HiOutlineGlobeAlt } from 'react-icons/hi';
import { MdOutlineExplore } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

// Import vehicle images (same as before)
// import sedan from "../../assets/image.png";
// import ertiga from "../../assets/image.png";
import crysta from "../../assets/image.png";
import hycross from "../../assets/image.png";
import fortuner from "../../assets/image.png";
import tempo from "../../assets/image.png";
import bus from "../../assets/image.png";
// import city from "../../assets/image.png";

const Y = "#28aa96";
const YD = "#020202";
const YL = "#FFF9E6";
const font = "'Nunito', sans-serif";


const sedan ="https://static.caronphone.com/public/brands/21/493/2518/2518_1731400393.webp"
const city=    "https://c4.wallpaperflare.com/wallpaper/614/644/854/2019-corolla-gli-toyota-wallpaper-thumb.jpg"
const ertiga ="https://imgd.aeplcdn.com/664x374/n/c6es93a_1572125.jpg?q=80"

const OUTSTATION_VEHICLES = [
  { 
    id: 1, 
    image: "sedan", 
    name: "Swift Dzire", 
    models: "Swift Dzire", 
    type: "Economy", 
    seaters: "4", 
    bags: 2, 
    price: "₹14/km", 
    minKm: 250,
    driverBata: "₹500/day",
    nightHalt: "₹400",
    tag: "Popular", 
    badge: "popular", 
    rating: 4.7, 
    features: ["Economy", "AC", "Music System"],
    ac: true,
    music: true
  },
  { 
    id: 2, 
    image: "premiumSedan", 
    name: "Toyota Etios", 
    models: "Toyota Etios", 
    type: "Comfort", 
    seaters: "4", 
    bags: 2, 
    price: "₹14/km", 
    minKm: 250,
    driverBata: "₹500/day",
    nightHalt: "₹400",
    tag: "Value", 
    badge: "value", 
    rating: 4.7, 
    features: ["Comfort", "AC", "USB Charging"],
    ac: true,
    music: true,
    charger: true
  },
  // { 
  //   id: 3, 
  //   image: "ertiga", 
  //   name: "Maruti Ertiga", 
  //   models: "Ertiga", 
  //   type: "Family", 
  //   seaters: "6", 
  //   bags: 4, 
  //   price: "₹18/km", 
  //   minKm: 250,
  //   driverBata: "₹500/day",
  //   nightHalt: "₹400",
  //   tag: "Best Value", 
  //   badge: "value", 
  //   rating: 4.6, 
  //   features: ["Family", "Extra Luggage", "3 Rows"],
  //   ac: true,
  //   music: true,
  //   charger: true
  // },
//   { 
//     id: 4, 
//     image: "crysta", 
//     name: "Innova Crysta", 
//     models: "Toyota Innova Crysta", 
//     type: "Premium", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹19/km", 
//     minKm: 300,
//     driverBata: "₹400/day",
//     nightHalt: "₹700",
//     tag: "Premium", 
//     badge: "top", 
//     rating: 4.9, 
//     features: ["Luxury", "Captain Seats", "Premium AC"],
//     ac: true,
//     music: true,
//     charger: true,
//     wifi: true
//   },
//   { 
//     id: 5, 
//     image: "hycross", 
//     name: "Innova Hycross", 
//     models: "Toyota Innova Hycross", 
//     type: "Luxury", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹23/km", 
//     minKm: 300,
//     driverBata: "₹400/day",
//     nightHalt: "₹700",
//     tag: "Luxury", 
//     badge: "top", 
//     rating: 5.0, 
//     features: ["Hybrid", "Panoramic Roof", "ADAS Safety"],
//     ac: true,
//     music: true,
//     charger: true,
//     wifi: true
//   }
];

const BADGES = {
  popular: { bg: "#FFF3CD", color: "#92400E", label: "🔥 Popular" },
  value: { bg: "#D1FAE5", color: "#065F46", label: "💎 Best Value" },
  top: { bg: "#FEE2E2", color: "#991B1B", label: "⭐ Top Pick" },
};

const getVehicleImage = (vehicle) => {
  const map = { 
    sedan: sedan,
    premiumSedan: city,
    ertiga: ertiga,
    crysta: crysta,
    hycross: hycross,
    fortuner: fortuner,
    tempo: tempo,
    bus: bus,
    default: crysta 
  };
  return map[vehicle.image] || map.default;
};

// Vehicle Card Component (similar to airport but with outstation details)
function VehicleCard({ v, onBook, onWhatsApp, index }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const bc = v.badge ? BADGES[v.badge] : null;
  const imageUrl = getVehicleImage(v);

  return (
    <div style={{
      background: "#fff",
      borderRadius: 24,
      overflow: "hidden",
      marginBottom: 16,
      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
      border: "1.5px solid #F0F0F0",
      transition: "all 0.3s ease",
      animation: `fadeIn 0.4s ${index * 0.06}s ease both`,
    }}>
      <div style={{ display: "flex", flexDirection: window.innerWidth <= 768 ? "column" : "row" }}>
        {/* Image Section - same as airport */}
        <div style={{
          position: "relative",
          width: window.innerWidth <= 768 ? "100%" : "280px",
          height: window.innerWidth <= 768 ? "180px" : "200px",
          background: "#f8f8f8",
          overflow: "hidden",
        }}>
          {!imageLoaded && <div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%)", backgroundSize: "200% 100%", animation: "shimmer 1.5s infinite" }} />}
          <img src={imageUrl} alt={v.name} onLoad={() => setImageLoaded(true)} style={{ width: "100%", height: "100%", objectFit: "contain", transition: "transform 0.5s ease", opacity: imageLoaded ? 1 : 0 }} />
          {bc && (
            <div style={{ position: "absolute", top: 12, left: 12, background: bc.bg, borderRadius: 20, padding: "4px 12px", zIndex: 2 }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: bc.color }}>{bc.label}</span>
            </div>
          )}
          <div style={{ position: "absolute", top: 12, right: 12, background: "rgba(255,255,255,0.95)", borderRadius: 20, padding: "4px 10px", display: "flex", alignItems: "center", gap: 4 }}>
            <Mountain size={10} color={Y} />
            <span style={{ fontSize: 10, fontWeight: 700 }}>Outstation</span>
          </div>
        </div>

        {/* Content Section */}
        <div style={{ flex: 1, padding: "16px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 900, color: "#1A1A1A", margin: "0 0 4px" }}>{v.name}</h3>
              <p style={{ fontSize: 12, color: "#666", margin: 0 }}>{v.models} • {v.type}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Star size={14} color={Y} fill={Y} />
              <span style={{ fontSize: 13, fontWeight: 700 }}>{v.rating}</span>
            </div>
          </div>

          <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Users size={14} color="#666" />
              <span style={{ fontSize: 12, color: "#666" }}>{v.seaters}+1</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Luggage size={14} color="#666" />
              <span style={{ fontSize: 12, color: "#666" }}>{v.bags} bags</span>
            </div>
          </div>

          {/* Pricing Card - Outstation specific */}
          <div style={{ background: "#F8F8F8", borderRadius: 16, padding: "12px 16px", marginBottom: 12, border: "1px solid #EEEEEE" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <div>
                <span style={{ fontSize: 11, color: "#666" }}>Per km</span>
                <div style={{ fontSize: 20, fontWeight: 900, color: "#1A1A1A" }}>{v.price}</div>
              </div>
              <div>
                <span style={{ fontSize: 11, color: "#666" }}>Min/day</span>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1A1A" }}>{v.minKm} km</div>
              </div>
              <div>
                <span style={{ fontSize: 11, color: "#666" }}>Driver bata</span>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1A1A" }}>{v.driverBata}</div>
              </div>
              <div>
                <span style={{ fontSize: 11, color: "#666" }}>Night halt</span>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1A1A" }}>{v.nightHalt}</div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => onBook(v)} style={{ flex: 1, background: Y, border: "none", color: "#1A1A1A", padding: "12px 0", borderRadius: 12, fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
              Book Now
            </button>
            <button onClick={() => onWhatsApp(v)} style={{ width: 44, height: 44, background: "#25D366", border: "none", color: "#fff", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <FaWhatsapp size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function OutstationTrips() {
  const [isMobile, setIsMobile] = useState(false);
  const [vehicles] = useState(OUTSTATION_VEHICLES);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBookNow = (vehicle) => {
    navigate('/booking', { 
      state: { 
        vehicle: vehicle,
        tripType: 'Outstation'
      } 
    });
  };

  const handleWhatsApp = (vehicle) => {
    const phoneNumber = "919150410309";
    const message = `Hello! I'm interested in booking ${vehicle.name} for outstation trip.`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const destinations = [
    { name: "Pondicherry", distance: "160 km", time: "3.5 hrs" },
    { name: "Mahabalipuram", distance: "55 km", time: "1.5 hrs" },
    { name: "Vellore", distance: "140 km", time: "3 hrs" },
    { name: "Kanchipuram", distance: "75 km", time: "2 hrs" },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#F5F5F5", fontFamily: font, padding: isMobile ? "20px 16px 60px" : "40px 20px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        *{box-sizing:border-box;}
        @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
      `}</style>

      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <div style={{ background: Y, borderRadius: 12, padding: 8 }}>
              <HiOutlineGlobeAlt size={24} color="#1A1A1A" />
            </div>
            <h1 style={{ fontSize: isMobile ? 28 : 36, fontWeight: 900, color: "#1A1A1A", margin: 0 }}>
              Outstation <span style={{ color: Y }}>Trips</span>
            </h1>
          </div>
          <p style={{ fontSize: 14, color: "#666", maxWidth: 500 }}>
            Explore beautiful destinations with our comfortable outstation cabs
          </p>
        </div>

        {/* Popular Destinations */}
        <div style={{ marginBottom: 30 }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: "#1A1A1A", marginBottom: 16 }}>
            Popular Destinations from Chennai
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)", gap: 12 }}>
            {destinations.map((dest, i) => (
              <div key={i} style={{ background: "#fff", borderRadius: 16, padding: 16, border: "1px solid #F0F0F0" }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#1A1A1A", marginBottom: 4 }}>{dest.name}</div>
                <div style={{ fontSize: 13, color: "#666" }}>{dest.distance} • {dest.time}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Vehicle List */}
        <div>
          {vehicles.map((vehicle, index) => (
            <VehicleCard
              key={vehicle.id}
              v={vehicle}
              index={index}
              onBook={handleBookNow}
              onWhatsApp={handleWhatsApp}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
